// extracted by mini-css-extract-plugin
export default {"row":"List_row__JoH4r","column":"List_column__nF6j+"};